var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticClass: "avue-crud" },
      [
        _c(
          "el-form",
          { attrs: { inline: true } },
          [
            _c(
              "el-form-item",
              { attrs: { label: "菜单名称", prop: "menuName" } },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入菜单名称",
                    clearable: "",
                    size: "small",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.getList.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.queryParams.menuName,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "menuName", $$v)
                    },
                    expression: "queryParams.menuName",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.getList },
                  },
                  [_vm._v("搜索")]
                ),
                _vm.permissions.sys_menu_add
                  ? _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-plus", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addOrUpdateHandle(false)
                          },
                        },
                      },
                      [_vm._v("\n          添加\n        ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              border: "",
              data: _vm.menuList,
              "row-key": "id",
              "tree-props": {
                children: "children",
                hasChildren: "hasChildrens",
              },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "name",
                label: "菜单名称",
                "show-overflow-tooltip": true,
                width: "180",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "icon",
                label: "图标",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("i", { class: scope.row.icon })]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "sortOrder", label: "排序", width: "60" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "path",
                label: "组件路径",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "menuType",
                label: "类型",
                width: "80",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.menuType === "0"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("左菜单"),
                          ])
                        : _vm._e(),
                      scope.row.menuType === "2"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("顶菜单"),
                          ])
                        : _vm._e(),
                      scope.row.menuType === "1"
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("按钮"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "keepAlive",
                label: "缓冲",
                width: "80",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.keepAlive === "0"
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("关闭"),
                          ])
                        : _vm._e(),
                      scope.row.keepAlive === "1"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("开启"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "visible",
                label: "显示状态",
                width: "80",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.visible === "1"
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("显示"),
                          ])
                        : _vm._e(),
                      scope.row.visible === "0"
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("隐藏"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "permission",
                label: "权限标识",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                "class-name": "small-padding fixed-width",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.permissions.sys_menu_add
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "text",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addOrUpdateHandle(
                                    false,
                                    scope.row.id
                                  )
                                },
                              },
                            },
                            [_vm._v("新增\n          ")]
                          )
                        : _vm._e(),
                      _vm.permissions.sys_menu_edit
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "text",
                                icon: "el-icon-edit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addOrUpdateHandle(
                                    true,
                                    scope.row.id
                                  )
                                },
                              },
                            },
                            [_vm._v("修改\n          ")]
                          )
                        : _vm._e(),
                      _vm.permissions.sys_menu_del
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "text",
                                icon: "el-icon-delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除\n          ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm.addOrUpdateVisible
          ? _c("table-form", {
              ref: "addOrUpdate",
              on: { refreshDataList: _vm.getList },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }